import { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Section } from "./About";

export default function Contact() {
  const { site } = useAuth();
  const s = site?.store || {};
  const [f, setF] = useState({ name: "", contact: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/contact", f);
      toast.success(data.message);
      setF({ name: "", contact: "", subject: "", message: "" });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Section eyebrow="Contact" title="We're here to help." text="Questions about an order, a payment or your account? Send us a message.">
      <div className="mt-14 grid gap-10 lg:grid-cols-5">
        <div className="space-y-4 lg:col-span-2">
          {[[Mail, "Email", s.support_email], [Phone, "Phone", s.support_phone || "Available via email"], [MapPin, "Location", s.address]].map(([I, l, v]) => (
            <div key={l} className="card-rx flex items-center gap-4 p-5">
              <I size={20} className="text-emerald-400" />
              <div><p className="text-xs text-slate-500">{l}</p><p className="text-sm font-medium text-white">{v}</p></div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="card-rx space-y-4 p-7 lg:col-span-3" data-testid="contact-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <input required minLength={2} value={f.name} onChange={set("name")} placeholder="Your name" className="input-rx" data-testid="contact-name-input" />
            <input required minLength={5} value={f.contact} onChange={set("contact")} placeholder="Phone or email" className="input-rx" data-testid="contact-contact-input" />
          </div>
          <input value={f.subject} onChange={set("subject")} placeholder="Subject (optional)" className="input-rx" data-testid="contact-subject-input" />
          <textarea required minLength={5} rows={6} value={f.message} onChange={set("message")} placeholder="How can we help?" className="input-rx" data-testid="contact-message-input" />
          <button disabled={busy} className="btn-primary w-full sm:w-auto" data-testid="contact-submit-btn">{busy ? "Sending…" : "Send message"}</button>
        </form>
      </div>
    </Section>
  );
}
